// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__mqj54","header":"MessagesList_header__1kKn2","chat":"MessagesList_chat__2IRec"};